<template>
    <div>
        <div class="mx-auto" style="max-width: 100%;">
            <b-card
                    v-for="(answer, answerKey) in answersAlt"
                    :key="answerKey"
                    :title="answer.titre"
                    class="my-3"
            >
                <h6 class="card-subtitle text-muted mb-3 d-block">{{ answer.category.name }}</h6>
                <p class="card-text">{{ answer.question }}</p>
                <details class="mb-3">
                    <summary><span class="text-primary">En savoir plus</span></summary>
                    <div class="p-3">{{ answer.info }}</div>
                </details>
                <b-btn
                        v-for="(step, ladderKey) in answer.category.ladder"
                        :key="ladderKey"
                        :value="ladderKey"
                        @click="select(answerKey, answer.id, ladderKey)"
                        :variant="isSelected(answer.id, ladderKey) ? 'primary':'outline-primary'"
                        block
                >
                    {{ step }}
                </b-btn>
            </b-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'evaluation-gollac',
        components: {},
        data: () => ({
            responses: []
        }),
        async mounted() {
            await this.$store.dispatch('base/evaluation/gollac/answers')
        },
        computed: {
            userId() {
                return parseInt(this.$route.params.id)
            },
            answers() {
                return this.$store.state.base.evaluation.gollac.answers
            },
            answersAlt() {
                const answers = Object.assign({}, this.answers)
                const answersAlt = []
                for (const categoryId in answers) {
                    const {titre, echelle, questions} = answers[categoryId]
                    for (const answerId in questions) {
                        const answerAlt = {}
                        answerAlt = questions[answerId]
                        answerAlt.category = {id: categoryId, title: titre, ladder: echelle}
                        answerAlt.id = answerId
                        answersAlt.push(answerAlt)
                    }
                }
                return answersAlt
            },
            completionPercentage() {
                return Math.round((this.responses.length / this.answersAlt.length) * 100)
            }
        },
        methods: {
            isSelected(question, response) {
                return this.responses.filter((r) => {
                    return r.answer === question && r.response === parseInt(response)
                }).length > 0
            },
            hasAnswered(response) {
                return this.responses.filter((r) => {
                    return r.answer === response
                }).length > 0
            },
            select(answerIndex, answerKey, ladderKey) {
                if (this.hasAnswered(answerKey)) {
                    this.responses.map((r) => {
                        if (r.answer === answerKey) {
                            r.response = parseInt(ladderKey)
                        }
                        return r
                    })
                } else {
                    this.responses.push({'answer': answerKey, 'response': parseInt(ladderKey)})
                }
                if (this.completionPercentage === 100) this.create()
            },
            async create() {
                this.$emit('change', this.responses)
            }
        }
    }
</script>
